module.exports = __webpack_public_path__ + "static/adults-296e2879ddb2802be9e458a82d815889.svg";